import { LeftRightBasedExpression } from '../LeftRightBasedExpression.js';
export class DivideExpression extends LeftRightBasedExpression {
    evaluate(visitor, localVariables) {
        const { left, right } = this._evaluateLeftRightExpression(visitor, localVariables);
        return left / right;
    }
}
//# sourceMappingURL=DivideExpression.js.map